import { CxEvent } from '@spartacus/core';

export class CitySetEvent extends CxEvent {
  static readonly type = 'CityChangedEvent';

  code: string;
}
